import React, { FC } from 'react';
import ArticleBox from '../../../components/ArticleBox';
import { IConfig } from '../../../types/config';
import { IArticle } from '../../../types/article';
import { IArticlesLatest1 } from './params';
import Styles from './styles';
import { common } from '../../../translates';

const ArticlesLatest: FC<{ config: IConfig; articles: IArticle[]; language: string }> = ({
  config,
  articles,
  language,
}) => (
  <Styles
    $config={config.home.articlesLatest.params as IArticlesLatest1}
    $articleBoxVariant={config.general.articleBox.variant}
  >
    <div className="articles-latest">
      <div className="container">
        <h3 className="articles-latest-header">{common[language].sectionArticlesLatest}</h3>
        <div className="articles-latest-list">
          {articles.map((article) => (
            <div key={article.id} className="articles-latest-category">
              {config.home.articlesLatest.params.boolean_category_above_box == 'true' ? (
                <h4 className="articles-latest-category-name">{article.categoryName}</h4>
              ) : null}
              <ArticleBox language={language} config={config} article={article} withCategory={false} />
            </div>
          ))}
        </div>
      </div>
    </div>
  </Styles>
);

export default ArticlesLatest;
